import React from "react";
import { Link } from "react-router-dom";
import { convertToUTCFormat, formatAmount } from "../utils/format";
import { format } from "date-fns";
import { getSortingClass, getTableStyles } from "../utils/bulkbankpaymenttable";
import PaginationButtons from "./PaginationButtons";

const BulkBankPaymentTable = ({
  caseData,
  bulkbankpaymentcheckboxes,
  handleBulkBankPaymentCheckboxChange,
  sortingColumns,
  handleSorting,
  page,
  prevPage,
  nextPage,
  pageSelected,
  editBulkPayment,
}) => {
  const areAllCheckboxesChecked = () => {
    if (!caseData.length) return false;

    let isChecked =
      Object.keys(bulkbankpaymentcheckboxes).length === caseData.length;
    if (!isChecked) return false;
    for (const val of Object.values(bulkbankpaymentcheckboxes)) {
      if (!val) return false;
    }
    return true;
  };
  return (
    <div role="tabpanel" className="tab-pane fade in active" id="mycase">
      <div>
        <div id="dtsMycase_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="dtsMycase"
            className="fmTableview display table table-bordered table-hover dataTable"
            cellSpacing="0"
            width="100%"
            role="grid"
          >
            <style>{getTableStyles()}</style>
            <thead>
              <tr role="row">
                <th
                  className="sorting_desc bulkbanklist-checkbox"
                  aria-label=""
                >
                  <input
                    type="checkbox"
                    className="withheld-panel-all-chkd"
                    id="chk"
                    name="selectall"
                    onChange={(e) => handleBulkBankPaymentCheckboxChange(e, -1)}
                    checked={areAllCheckboxesChecked()}
                  />
                  <label htmlFor="chk">
                    <span className="dt-yes"></span>
                  </label>
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "lead_id"
                  )} bulkbanklist-lead-id`}
                  onClick={() => handleSorting("lead_id")}
                >
                  Loan ID
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "bank_payment"
                  )} bulkbanklist-bank-payment`}
                  onClick={() => handleSorting("bank_payment")}
                >
                  Bank Payment
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "payment_date"
                  )} bulkbanklist-payment-date`}
                  onClick={() => handleSorting("payment_date")}
                >
                  Payment Date
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "bank"
                  )} bulkbanklist-bank`}
                  onClick={() => handleSorting("bank")}
                >
                  Bank
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "city"
                  )} bulkbanklist-city`}
                  onClick={() => handleSorting("city")}
                >
                  City
                </th>
                <th className="sorting_disabled bulkbanklist-previous-payment">
                  Previous Payment
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "cus_name"
                  )} bulkbanklist-customer`}
                  onClick={() => handleSorting("cus_name")}
                >
                  Customer Name
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "regno"
                  )} bulkbanklist-car-regno`}
                  onClick={() => handleSorting("regno")}
                >
                  Car Reg no.
                </th>
                <th className="sorting_disabled bulkbanklist-car-name">
                  Car name
                </th>
                <th className="sorting_disabled bulkbanklist-added-by">
                  Added By
                </th>
                <th className="sorting_disabled bulkbanklist-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {!caseData.length ? (
                <tr className="odd">
                  <td valign="top" colSpan="14" className="dataTables_empty">
                    No data available in table
                  </td>
                </tr>
              ) : (
                ""
              )}
              {caseData.map((caseObj, idx) => {
                const {
                  finance_lead_id,
                  bulk_payment_id,
                  bank_payment_amount,
                  bank_payment_date,
                  bank_name,
                  lead_city,
                  customer_name,
                  last_name,
                  regno,
                  make,
                  model,
                  variant_name,
                  user_name,
                  previousPayment,
                  receiving_bank,
                  utr_narration,
                  transaction_id,
                } = caseObj;
                return (
                  <tr
                    role="row"
                    className={`${idx % 2 === 1 ? "even" : "light_row"}`}
                    key={idx}
                  >
                    <td className="sorting_1">
                      <input
                        className="bulk-payment-chkd disabled-group"
                        type="checkbox"
                        id={`chk_${bulk_payment_id}`}
                        value={bulk_payment_id}
                        onChange={(e) =>
                          handleBulkBankPaymentCheckboxChange(
                            e,
                            bulk_payment_id
                          )
                        }
                        checked={
                          bulkbankpaymentcheckboxes[bulk_payment_id] || false
                        }
                      />
                      <label htmlFor={`chk_${bulk_payment_id}`}>
                        <span className="dt-yes"></span>
                      </label>
                    </td>
                    <td>
                      <Link
                        to={`/payments/details?lead_id=${btoa(
                          finance_lead_id
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="withheld-panel-lead-id"
                      >
                        {finance_lead_id}
                      </Link>
                    </td>
                    <td>{formatAmount(bank_payment_amount)}</td>
                    <td>
                      {bank_payment_date
                        ? convertToUTCFormat(
                            new Date(bank_payment_date),
                            "dd-MM-yyyy"
                          )
                        : "00-00-0000"}
                    </td>
                    <td>{bank_name}</td>
                    <td>{lead_city}</td>
                    <td>{formatAmount(previousPayment)}</td>
                    <td>{`${customer_name} ${last_name}`}</td>
                    <td>{regno}</td>
                    <td>{`${make} ${model} ${variant_name}`}</td>
                    <td>{user_name}</td>
                    <td>
                      <div className="btn-group">
                        <button
                          className="btn btn-edit-user"
                          onClick={(e) => {
                            editBulkPayment(
                              receiving_bank,
                              bank_payment_amount,
                              bank_payment_date,
                              finance_lead_id,
                              bulk_payment_id,
                              utr_narration,
                              transaction_id
                            );
                            e.stopPropagation();
                          }}
                        >
                          <span className="fa fa-pencil mrg-R5"></span>
                          Edit
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <PaginationButtons
            page={page}
            total={caseData.length}
            prevPage={prevPage}
            nextPage={nextPage}
            pageSelected={pageSelected}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkBankPaymentTable;
